<template>
  <div class="space-y-1">
    <label class="text-xs text-gray-400">Currency Filters</label>
    <BaseSelect
      :multiple="true"
      :placeholder="'Select Currency Filters'"
      :options="currenciesOptions"
      v-model="currenciesSelected"
      button-width-class="w-full truncate"
      dropdown-width-class="w-full"
    />
  </div>
</template>
<script>

export default {
  name: 'WidgetConfigsTradingviewEconomicCalendar',
  emits: ['update'],
  props: {
    config: {
      type: Object
    }
  },
  mounted() {
    if (!this.config?.currenciesSelected)
      this.currenciesSelected = this.defaultCurrencies;
  },
  data() {
    return {
      defaultCurrencies: [
        'AUD',
        'USD',
        'CAD',
        'EUR',
        'FRF',
        'DEM',
        'ITL',
        'JPY',
        'MXN',
        'NZD',
        'ZAR',
        'ESP',
        'CHF',
        'TRL',
        'GBP'
      ],
      currenciesSelected: this.config?.currenciesSelected || []
    };
  },
  computed: {
    currenciesOptions () {
      return this.defaultCurrencies.map(x => {
        return {
          id: x,
          label: x
        };
      });
    }
  },
  watch: {
    currenciesSelected() {
      this.updateConfiguration();
    }
  },
  methods: {
    updateConfiguration() {
      this.configuration = {
        currenciesSelected: this.currenciesSelected,
        valid: true
      };
      this.$emit('update', this.configuration);
    }
  }
};
</script>
